import api from './axiosInstance';

export const addOnApi = {
  list: () => api.get('/addons'),
  create: (data) => api.post('/addons', data),
  update: (id, data) => api.put(`/addons/${id}`, data),
  remove: (id) => api.delete(`/addons/${id}`),
};
